import { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  Grid,
  DialogActions,
  Button,
} from "@material-ui/core";
import { Close, FileUpload } from "@mui/icons-material";
import Api from "lib/api/httpRequestHelper";
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import UtilsFncs from "utils/UtilsFncs";
import UploadFile from "components/_refactor/dropzone";

export default function DialogSendDocument({
  onClose,
  idSolicitacao,
  handleSearch,
}) {
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const snackbar = useSnackbar();

  const handleMediaUpload = async () => {
    if (files.length !== 2) {
      snackbar.showMessage(
        "Selecione o XML e o PDF da nota fiscal para enviar",
        {
          severity: "warning",
        }
      );
      return;
    }

    const xmlFile = files.find((file) =>
      file.name.toLowerCase().endsWith(".xml")
    );
    const pdfFile = files.find((file) =>
      file.name.toLowerCase().endsWith(".pdf")
    );

    if (!xmlFile || !pdfFile) {
      snackbar.showMessage(
        "É necessário enviar um arquivo XML e um arquivo PDF",
        {
          severity: "warning",
        }
      );
      return;
    }

    setLoading(true);

    try {
      const base64Xml = await UtilsFncs.FileToB64(xmlFile);
      let encodedBase64Xml = base64Xml?.toString()?.replace(/^data:(.*,)?/, "");

      if (encodedBase64Xml.length % 4 > 0) {
        encodedBase64Xml += "=".repeat(4 - (encodedBase64Xml.length % 4));
      }

      await Api.put(
        "upload-document",
        "returnRequest",
        {
          idSolicitacao,
          tipoDocumento: "XML",
          base64: encodedBase64Xml,
          nomeArquivo: xmlFile.name,
          tamanhoBytes: xmlFile.size,
        },
        true
      );

      const base64Pdf = await UtilsFncs.FileToB64(pdfFile);
      let encodedBase64Pdf = base64Pdf?.toString()?.replace(/^data:(.*,)?/, "");

      if (encodedBase64Pdf.length % 4 > 0) {
        encodedBase64Pdf += "=".repeat(4 - (encodedBase64Pdf.length % 4));
      }

      await Api.put(
        "upload-document",
        "returnRequest",
        {
          idSolicitacao,
          tipoDocumento: "PDF",
          base64: encodedBase64Pdf,
          nomeArquivo: pdfFile.name,
          tamanhoBytes: pdfFile.size,
        },
        true
      );

      snackbar.showMessage("Documentos enviados com sucesso", {
        severity: "success",
      });

      onClose();
      handleSearch();
    } catch (error) {
      snackbar.showMessage("Erro ao enviar documentos", {
        severity: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open onClose={onClose} maxWidth="md">
      <DialogTitle>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h3" color="primary">
            <FileUpload style={{ marginRight: "12px" }} />
            Enviar Documento
          </Typography>
          <IconButton onClick={onClose}>
            <Close />
          </IconButton>
        </div>
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <UploadFile
              multiple={true}
              accept={[".xml", ".pdf"]}
              message="Selecione o arquivo XML e o PDF da nota fiscal ou arraste aqui"
              validator={(file) => {
                const fileName = file.name.toLowerCase();
                const isXml = fileName.endsWith(".xml");
                const isPdf = fileName.endsWith(".pdf");

                if (!isXml && !isPdf) {
                  return {
                    code: "file-invalid-type",
                    message: "Apenas arquivos XML e PDF são permitidos",
                  };
                }

                if (file.size > 1024 * 1024) {
                  return {
                    code: "file-too-large",
                    message: "O arquivo deve ter no máximo 1MB",
                  };
                }

                return null;
              }}
              onChangeFiles={(newFiles) => {
                if (newFiles && newFiles.length > 2) {
                  snackbar.showMessage(
                    "Somente é permitido enviar 2 arquivos",
                    {
                      severity: "error",
                    }
                  );
                  setFiles(newFiles);
                } else {
                  setFiles(newFiles || []);
                }
              }}
              disabled={loading}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="primary" onClick={onClose}>
          Cancelar
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={handleMediaUpload}
          disabled={loading || files.length !== 2}
        >
          {loading ? "Enviando..." : "Enviar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
